import type { Observable } from "rxjs";
import { publishReplay, refCount } from "rxjs/operators";

const cache: {
    [index: string]: Observable<any>;
} = {};

export function TTLCacheObservable(ttl = 1000) {
    return (target: any, methodName: string, descriptor: PropertyDescriptor) => {
        descriptor = descriptor || Object.getOwnPropertyDescriptor(target, methodName); // eslint-disable-line

        const original: (...args: any[]) => Observable<any> = descriptor.value;
        const targetName: string = target.constructor.name;

        return Object.defineProperty(target, methodName, {
            value(...args: any[]) {
                const key = `${targetName}:${methodName}:${JSON.stringify(args)}`;

                const entry: Observable<any> = cache[key];
                if (entry) {
                    return entry;
                }

                cache[key] = original.apply(this, args).pipe(publishReplay(1), refCount());

                setTimeout(() => {
                    cache[key] = null;
                }, ttl);

                return cache[key];
            },
        });
    };
}
